// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-up-enter-active[data-v-ca9cca1e],.slide-up-leave-active[data-v-ca9cca1e]{transition:transform .3s ease,opacity .3s ease}.slide-up-enter[data-v-ca9cca1e],.slide-up-leave-to[data-v-ca9cca1e]{opacity:0;transform:translateY(100%)}.fade-enter-active[data-v-ca9cca1e],.fade-leave-active[data-v-ca9cca1e]{transition:opacity .15s ease}.fade-enter[data-v-ca9cca1e],.fade-leave-to[data-v-ca9cca1e]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
